var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.351074 30.5002C0.351074 13.8493 13.8493 0.351074 30.5002 0.351074C47.1512 0.351074 60.6494 13.8493 60.6494 30.5002C60.6494 47.1512 47.1512 60.6494 30.5002 60.6494C13.8493 60.6494 0.351074 47.1512 0.351074 30.5002Z",
    fill: "#DDFBE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3755 15.5007C22.1107 15.5694 15.432 22.3603 15.5008 30.625C15.5696 38.8897 22.3604 45.5684 30.6251 45.4996C38.8898 45.4309 45.5685 38.64 45.4998 30.3753C45.431 22.1106 38.6402 15.4319 30.3755 15.5007ZM37.6413 26.9906L29.2074 35.5661C28.9991 35.7778 28.7151 35.9002 28.4152 35.9027C28.1152 35.9052 27.8292 35.7876 27.6174 35.5793L23.3373 31.3698C22.8987 30.9384 22.8927 30.2184 23.324 29.7798C23.7554 29.3412 24.4754 29.3352 24.914 29.7666L28.3926 33.1878L36.0381 25.4139C36.4695 24.9753 37.1895 24.9693 37.6281 25.4007C38.0667 25.832 38.0726 26.537 37.6413 26.9906Z",
    fill: "#1B9E40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickGreen);
export default __webpack_public_path__ + "static/media/tick_green.016e4e1e4178b557ef8ac40a60dc464b.svg";
export { ForwardRef as ReactComponent };